module.exports = __webpack_public_path__ + "img/sad.bb6a283b.svg";